/* Appens versionsnummer — höj här vid varje release. */
export const APP_VERSION = '1.10.0';
